import { Box } from "@mui/material";

import { heroVehicleImageSx } from "@/src/pages/consumer/HomePage/components/HomePageHeader/homePageHeader.styles";

import heroVehiclesWebp from "@/assets/images/hero_vehicles.webp";

const HeroVehicleImage = () => (
  <Box
    component="img"
    src={heroVehiclesWebp}
    alt=""
    aria-hidden
    sx={heroVehicleImageSx}
  />
);

export default HeroVehicleImage;
